// Marcadores del mapa del detalle de pedido, como HTML. Sin Leaflet: lo usan el
// mapa (L.divIcon en leafletMap.jsx) y la leyenda del detalle, que así se ve
// igual que el mapa.

// Glifos de lucide (house, check, undo-2) como SVG estático: el ícono de un
// marcador de Leaflet es HTML, no un componente React.
const svg = (paths) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;
const GLYPHS = {
  address: svg('<path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"/><path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>'),
  delivered: svg('<path d="M20 6 9 17l-5-5"/>'),
  returned: svg('<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11"/>'),
};

export const MARKER_SIZE = 28;
export const PIN_WIDTH = 28;
export const PIN_HEIGHT = 36;
const PIN_PATH = 'M14 1C6.8 1 1 6.7 1 13.8 1 23.2 14 35 14 35s13-11.8 13-21.2C27 6.7 21.2 1 14 1z';

/**
 * HTML del marcador. Sólo arma piezas fijas de este archivo y un número, así
 * que es seguro como HTML; la leyenda del detalle lo reutiliza para verse igual.
 *
 * Los eventos (intento, entrega, devolución) son un círculo centrado EN el punto.
 * La dirección es un pin cuya punta marca el punto: una entrega a pocos metros
 * cae en la punta y no tapa la dirección. Colores por clase (evidenceView.scss)
 * para respetar tema y modo daltónico.
 */
export function markerHtml(kind, attempt) {
  if (kind === 'address') {
    return `<span class="pd-marker__pin"><svg viewBox="0 0 28 36" aria-hidden="true"><path d="${PIN_PATH}"/></svg><span class="pd-marker__pin-glyph">${GLYPHS.address}</span></span>`;
  }
  const content = kind === 'failed' ? String(Number(attempt) || '') : GLYPHS[kind] || '';
  return `<span class="pd-marker__dot">${content}</span>`;
}
